import { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import FormWebhookTargetUrlDelete from './FormWebhookTargetUrlDelete'
import FormWebhookTargetUrlEdit from './FormWebhookTargetUrlEdit'
import FormWebhookTargetUrlAdd from './FormWebhookTargetUrlAdd'
import { useTheme } from 'styled-components'
import styled from 'styled-components'
import {
  DataTable,
  DataRow,
  DataHeader,
  DataCell,
  IconEdit,
  IconHelp,
  IconRemove,
} from './CommonStylesTables'
import { Button } from './CommonStylesForms'

const StyledDataRow = styled(DataRow)`
  :nth-child(2n + 2) td {
    background: ${(props) => props.theme.background_secondary};
  }

  :hover td {
    cursor: default;
    background: #ffc;
  }
`

const StyledDataCell = styled(DataCell)`
  :hover {
    cursor: pointer !important;
  }
`

const StyledButton = styled(Button)`
  margin-left: 15px;
  margin-bottom: 15px;
  display: block;
`

function WebhookTargetUrls(props) {
  const theme = useTheme()
  const webhookTargetUrls = props.settingsState.webhookTargetUrls
  const { setNotificationState, SettingsHeader } = props
  const [targetUrl, setTargetUrl] = useState('')
  const [addWebhookUrlModalIsOpen, setAddWebhookUrlModalIsOpen] = useState(
    false
  )
  const [editWebhookUrlModalIsOpen, setEditWebhookUrlModalIsOpen] = useState(
    false
  )
  const [
    deleteWebhookUrlModalIsOpen,
    setDeleteWebhookUrlModalIsOpen,
  ] = useState(false)

  const closeAddModal = () => setAddWebhookUrlModalIsOpen(false)
  const closeEditModal = () => setEditWebhookUrlModalIsOpen(false)
  const closeDeleteModal = () => setDeleteWebhookUrlModalIsOpen(false)

  const addWebhookUrl = () => {
    setAddWebhookUrlModalIsOpen(true)
  }

  const editWebhookUrl = () => {
    setEditWebhookUrlModalIsOpen(true)
  }

  const deleteWebhookUrl = () => {
    setDeleteWebhookUrlModalIsOpen(true)
  }

  const verificationDefinitionRows = webhookTargetUrls.map((url, index) => {
    return (
      <StyledDataRow key={index}>
        <DataCell>{url}</DataCell>
        <DataCell />
        <DataCell />
        <DataCell />
        <DataCell />
        <DataCell />
        <StyledDataCell
          onClick={() => {
            editWebhookUrl()
            setTargetUrl(url)
          }}
        >
          <IconEdit alt="Edit" />
        </StyledDataCell>
        <StyledDataCell
          onClick={() => {
            deleteWebhookUrl()
            setTargetUrl(url)
          }}
        >
          <IconRemove alt="Remove" />
        </StyledDataCell>
      </StyledDataRow>
    )
  })

  return (
    <>
      <SettingsHeader>Webhook Target URLs</SettingsHeader>
      <IconHelp
        data-tip
        data-for="organizationTip"
        data-delay-hide="250"
        data-multiline="true"
        alt="Help"
      />
      <ReactTooltip
        id="organizationTip"
        effect="solid"
        type="info"
        backgroundColor={theme.primary_color}
      >
        <span>
          Webhook Target URLs are the URLs
          <br />
          that will receive the webhook
          <br />
          data from events emitted by Proven.
        </span>
      </ReactTooltip>
      <>
        <StyledButton onClick={addWebhookUrl} id="button-schema-add">
          Add
        </StyledButton>
      </>
      <DataTable>
        <thead>
          <StyledDataRow>
            <DataHeader>URL</DataHeader>
            <DataHeader> </DataHeader>
            <DataHeader> </DataHeader>
            <DataHeader> </DataHeader>
            <DataHeader> </DataHeader>
            <DataHeader> </DataHeader>
            <DataHeader>Edit</DataHeader>
            <DataHeader>Remove</DataHeader>
          </StyledDataRow>
        </thead>
        <tbody>{verificationDefinitionRows}</tbody>
      </DataTable>
      <FormWebhookTargetUrlDelete
        sendRequest={props.sendRequest}
        url={targetUrl}
        webhookTargetUrls={webhookTargetUrls}
        deleteWebhookUrlModalIsOpen={deleteWebhookUrlModalIsOpen}
        closeDeleteModal={closeDeleteModal}
      />
      <FormWebhookTargetUrlEdit
        setNotificationState={setNotificationState}
        sendRequest={props.sendRequest}
        url={targetUrl}
        webhookTargetUrls={webhookTargetUrls}
        editWebhookUrlModalIsOpen={editWebhookUrlModalIsOpen}
        closeEditModal={closeEditModal}
      />
      <FormWebhookTargetUrlAdd
        setNotificationState={setNotificationState}
        sendRequest={props.sendRequest}
        url={targetUrl}
        webhookTargetUrls={webhookTargetUrls}
        addWebhookUrlModalIsOpen={addWebhookUrlModalIsOpen}
        closeAddModal={closeAddModal}
      />
    </>
  )
}

export default WebhookTargetUrls
